import { Link, withRouter } from 'react-router-dom';
import React, { Component } from 'react';

import Lottie from 'lottie-react';
import PropTypes from 'prop-types';
import confeti from './../../images/anims/kupos_confetti_alone.json';
import cross from './../../images/anims/xmark_anim.json';
import tick from './../../images/anims/checkmark_anim.json';

export default class KuposSuccessFailure extends Component {
	static propTypes = {
		success: PropTypes.bool,
		title: PropTypes.string,
		subtitle: PropTypes.string,
		infoText: PropTypes.string,
		icon: PropTypes.string,
		t: PropTypes.func,
		operator: PropTypes.object,
	};

	render() {
		let metaData = JSON.parse(localStorage.getItem('metaData') || '');
		let operator =
			metaData &&
			metaData.operator_sites &&
			metaData.operator_sites.operator &&
			metaData.operator_sites.operator;
		return (
			<div className="common-kupos-success-failure">
				<div
					className="content-container cancel-done-section"
					style={{
						marginTop:
							this.props && this.props.operator && this.props.operator.theme_type == 9
								? '30vh'
								: '20vh',
					}}
				>
					<div className="cancel-ticket-done">
						{this.props.success ? (
							// <div style={{ position: 'absolute', zIndex: 99, width: '100vw', height: '50vh' }}>
							<Lottie
								animationData={confeti}
								loop={false}
								style={{ position: 'absolute', zIndex: 99, width: '100vw', height: '50vh' }}
							/>
						) : // </div>
							null}

						<div className="anim-container" style={{ height: 90, width: 'auto' }}>
							{this.props.icon ? (
								<img src={this.props.icon} alt="" />
							) : this.props.success ? (
								<Lottie animationData={tick} loop={false} />
							) : (
								<Lottie animationData={cross} loop={false} />
							)

								// <img src={this.props.success ? "/images/icons/circular-icons/icon-success.png" : "/images/icons/circular-icons/icon-failure.png"} alt="" />
							}
						</div>
					</div>

					<div className="mt-y-3 cancel-ticket-done">
						<span className="bold-text font20">
							{this.props.title
								? this.props.title
								: this.props.success
									? this.props.t
										? this.props.t('HOME.THANK_YOU')
										: '¡Listo!'
									: this.props.t
										? this.props.t('HOME.WE_ARE_SORRY')
										: '¡Lo sentimos!'}
						</span>
					</div>

					<div className="mt-y-3 cancel-ticket-done cancel-ticket-done-desc font12">
						<span style={{ textAlign: 'center' }}>{this.props.subtitle}</span>
					</div>

					<style>
						.common-kupos-success-failure .primary-triangle {'{'}
						border-bottom: 19px solid{' '}
						{this.props.operator &&
							this.props.operator.color_codes &&
							this.props.operator.color_codes.secondary_color
							? this.props.operator.color_codes.secondary_color
							: ''}
						;{'}'}
					</style>

					{this.props.infoText ? (
						<div className="cancel-success-info-container">
							<div
								style={{
									backgroundColor:
										operator &&
											operator.color_codes &&
											operator.color_codes.secondary_color
											? operator.color_codes.secondary_color
											: '',
								}}
								className="mt-y-3 cancel-ticket-done cancel-success-info-div font12"
							>
								<span className="primary-triangle"></span>
								<span>{this.props.infoText} </span>
							</div>
						</div>
					) : null}
				</div>

				{this.props.children ? (
					<div
						className="content-container success-failure-content"
						style={
							this.props.success
								? {
									zIndex: 100,
									position: 'absolute',
									minWidth: '100vw',
								}
								: {}
						}
					>
						{this.props.children}
					</div>
				) : null}

				<div className="content-container download-our-app-section-container">
					{/* {!this.props.operator
            &&
            <div className="download-our-app-section">
              <img className="banner-back" src="/images/download-success-page-banner-2.png" />
              <div className="download-app-overlay-text-items">
                <span className="download-app-overlay-text-heading bold-text font24">
                  {this.props.t('HOME.DOWNLOAD_OUR_APP')}
                </span>

                <span className="download-app-overlay-text-details font12">
                  {this.props.t('HOME.CREATE_TICKET')}
                </span>
                <div className="download-app-kupos-pay-image">
                  <img src="/images/kupos_pay_logo.svg" alt="" />
                </div>
                <div className="download-app-kupos-pay-image download-app-kupos-pay-store">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.bitla.mba.pasajebus"
                    target="_blank"
                  >
                    <img
                      src={this.props.t('HOME.GOOGLE_PLAY_DARK')}
                      alt={this.props.t('TRANSLATIONS.GPLAY')}
                    />
                  </a>
                  <a
                    href="https://itunes.apple.com/us/app/pasaje-bus/id973424151?ls=1&amp;mt=8"
                    target="_blank"
                  >
                    <img
                      src={this.props.t('HOME.APP_STORE_DARK')}
                      alt={this.props.t('TRANSLATIONS.APPSTORE')}
                    />
                  </a>
                </div>
              </div>
            </div>
          } */}
				</div>

				{this.props.success ? (
					<audio
						ref={audio => {
							this.audio = audio;
						}}
						// controls
						autoPlay={true}
						src="https://kupos.s3.amazonaws.com/kupos_success_sound.mpeg"
					/>
				) : null}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/features/common/KuposSuccessFailure.js